/* tslint:disable */
import {
  Case,
  Job,
  WorkOrder
} from '../index';

declare var Object: any;
export interface CsqdActivityInterface {
  "sfdcId"?: string;
  "Account__c"?: string;
  "Action__c"?: string;
  "Appointment__c"?: string;
  "Case__c"?: string;
  "Comment_Body__c"?: string;
  "Comment_Id__c"?: string;
  "CreatedById"?: string;
  "CreatedDate"?: Date;
  "CurrencyIsoCode"?: string;
  "FROM_Value__c"?: string;
  "Field__c"?: string;
  "IsDeleted"?: boolean;
  "Job__c"?: string;
  "LastModifiedById"?: string;
  "LastModifiedDate"?: Date;
  "LastReferencedDate"?: Date;
  "LastViewedDate"?: Date;
  "Logged_In_Contact__c"?: string;
  "Name"?: string;
  "Object_API_Name__c"?: string;
  "OwnerId"?: string;
  "PgMO_Access_Control__c"?: string;
  "PgMO_Assignment__c"?: string;
  "PgMO_Member_Role__c"?: string;
  "PgMO_Milestone__c"?: string;
  "PgMO_Program_Group__c"?: string;
  "PgMO_Programs__c"?: string;
  "PgMO_Projects__c"?: string;
  "PgMO_Tasks__c"?: string;
  "To_Value__c"?: string;
  "User_Name__c"?: string;
  "Work_Order__c"?: string;
  "Timecard_Timesheet__c"?: string;
  "id"?: number;
  case?: Case;
  job?: Job;
  workOrder?: WorkOrder;
}

export class CsqdActivity implements CsqdActivityInterface {
  "sfdcId": string;
  "Account__c": string;
  "Action__c": string;
  "Appointment__c": string;
  "Case__c": string;
  "Comment_Body__c": string;
  "Comment_Id__c": string;
  "CreatedById": string;
  "CreatedDate": Date;
  "CurrencyIsoCode": string;
  "FROM_Value__c": string;
  "Field__c": string;
  "IsDeleted": boolean;
  "Job__c": string;
  "LastModifiedById": string;
  "LastModifiedDate": Date;
  "LastReferencedDate": Date;
  "LastViewedDate": Date;
  "Logged_In_Contact__c": string;
  "Name": string;
  "Object_API_Name__c": string;
  "OwnerId": string;
  "PgMO_Access_Control__c": string;
  "PgMO_Assignment__c": string;
  "PgMO_Member_Role__c": string;
  "PgMO_Milestone__c": string;
  "PgMO_Program_Group__c": string;
  "PgMO_Programs__c": string;
  "PgMO_Projects__c": string;
  "PgMO_Tasks__c": string;
  "To_Value__c": string;
  "User_Name__c": string;
  "Work_Order__c": string;
  "Timecard_Timesheet__c": string;
  "id": number;
  case: Case;
  job: Job;
  workOrder: WorkOrder;
  constructor(data?: CsqdActivityInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CsqdActivity`.
   */
  public static getModelName() {
    return "CsqdActivity";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CsqdActivity for dynamic purposes.
  **/
  public static factory(data: CsqdActivityInterface): CsqdActivity{
    return new CsqdActivity(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'CsqdActivity',
      plural: 'CsqdActivities',
      path: 'CsqdActivities',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "Account__c": {
          name: 'Account__c',
          type: 'string'
        },
        "Action__c": {
          name: 'Action__c',
          type: 'string'
        },
        "Appointment__c": {
          name: 'Appointment__c',
          type: 'string'
        },
        "Case__c": {
          name: 'Case__c',
          type: 'string'
        },
        "Comment_Body__c": {
          name: 'Comment_Body__c',
          type: 'string'
        },
        "Comment_Id__c": {
          name: 'Comment_Id__c',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "CreatedDate": {
          name: 'CreatedDate',
          type: 'Date'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "FROM_Value__c": {
          name: 'FROM_Value__c',
          type: 'string'
        },
        "Field__c": {
          name: 'Field__c',
          type: 'string'
        },
        "IsDeleted": {
          name: 'IsDeleted',
          type: 'boolean'
        },
        "Job__c": {
          name: 'Job__c',
          type: 'string'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "LastModifiedDate": {
          name: 'LastModifiedDate',
          type: 'Date'
        },
        "LastReferencedDate": {
          name: 'LastReferencedDate',
          type: 'Date'
        },
        "LastViewedDate": {
          name: 'LastViewedDate',
          type: 'Date'
        },
        "Logged_In_Contact__c": {
          name: 'Logged_In_Contact__c',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "Object_API_Name__c": {
          name: 'Object_API_Name__c',
          type: 'string'
        },
        "OwnerId": {
          name: 'OwnerId',
          type: 'string'
        },
        "PgMO_Access_Control__c": {
          name: 'PgMO_Access_Control__c',
          type: 'string'
        },
        "PgMO_Assignment__c": {
          name: 'PgMO_Assignment__c',
          type: 'string'
        },
        "PgMO_Member_Role__c": {
          name: 'PgMO_Member_Role__c',
          type: 'string'
        },
        "PgMO_Milestone__c": {
          name: 'PgMO_Milestone__c',
          type: 'string'
        },
        "PgMO_Program_Group__c": {
          name: 'PgMO_Program_Group__c',
          type: 'string'
        },
        "PgMO_Programs__c": {
          name: 'PgMO_Programs__c',
          type: 'string'
        },
        "PgMO_Projects__c": {
          name: 'PgMO_Projects__c',
          type: 'string'
        },
        "PgMO_Tasks__c": {
          name: 'PgMO_Tasks__c',
          type: 'string'
        },
        "To_Value__c": {
          name: 'To_Value__c',
          type: 'string'
        },
        "User_Name__c": {
          name: 'User_Name__c',
          type: 'string'
        },
        "Work_Order__c": {
          name: 'Work_Order__c',
          type: 'string'
        },
        "Timecard_Timesheet__c": {
          name: 'Timecard_Timesheet__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        case: {
          name: 'case',
          type: 'Case',
          model: 'Case',
          relationType: 'belongsTo',
                  keyFrom: 'Case__c',
          keyTo: 'sfdcId'
        },
        job: {
          name: 'job',
          type: 'Job',
          model: 'Job',
          relationType: 'belongsTo',
                  keyFrom: 'Job__c',
          keyTo: 'sfdcId'
        },
        workOrder: {
          name: 'workOrder',
          type: 'WorkOrder',
          model: 'WorkOrder',
          relationType: 'belongsTo',
                  keyFrom: 'Work_Order__c',
          keyTo: 'sfdcId'
        },
      }
    }
  }
}
